import Vue from 'vue';
import CookieSettings from "./CookieSettings.vue";
import i18n from '@/lang/i18n';


import '@/assets/css/global.scss';

new Vue({
    i18n,
    el: '#cookie-settings',
    render: h => h(CookieSettings)
  })